module.exports = __webpack_public_path__ + "static/media/PlusCircle.503e148c.svg";